import "./color-preview.component.less"

export const ColorPreviewComponent = {
    bindings: {
        color: "<",
        name: "<"
    },
    template: `<div class="circle" ng-style="{ background: $ctrl.color }"></div> {{ $ctrl.name }}`
}
